import react from "react";

const SocialLinkInputModal = (props) => {
    const { platform, url, onChange, placeholder, dismiss } = props;

    const [inputValue, setInputValue] = react.useState(placeholder || "");
    
    const handleSubmit = () => {
        onChange?.(platform, inputValue);
        dismiss?.();
    }

    return (
        <div style={{ display: props?.show ? 'block' : 'none' }} className='a-modal-container'>
            <div className="a-modal-overlay" onClick={props?.dismiss}></div>
            <div className="a-modal">
                <div className="a-modal-header">
                    <h2 className="lucky-font">Add {platform}</h2>
                </div>
                <div className='a-modal-body lato-font'>
                    <>
                        <div style={{ 
                            padding: '0 10px', 
                            borderRadius: '8px',
                            marginBottom: '10px'
                        }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', justifyContent: 'center', marginTop: '10px' }}>
                                <div>
                                    <input
                                        type="text"
                                        placeholder={placeholder}
                                        value={inputValue}
                                        onChange={(e) => {
                                            setInputValue(e.target.value);
                                        }}
                                        style={{
                                            flex: 1,
                                            padding: '12px 20px',
                                            borderRadius: '8px',
                                            border: '1px solid #ccc',
                                            fontSize: '1em',
                                            height: "40px",
                                            width: '250px'
                                        }}
                                    />
                               </div>
                                <div
                                    onClick={handleSubmit}
                                    style={{
                                        background: '#007bff',
                                        color: 'white',
                                        padding: '12px 24px',
                                        borderRadius: '8px',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '1em',
                                        display: 'inline-block',
                                        textAlign: 'center',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Add
                                </div>
                            </div>
                        </div>
                    </>
                </div>
            </div>
        </div>
      );
    
};

export default SocialLinkInputModal;

